<template>
  <div class="guides">
    <guide
      v-for="guide in initGuides"
      :key="guide.id"
      :guide="guide"
      :reset-guide-text="resetGuideText"
      @close="guideClosed(guide.id)"
      @open="guideOpened(guide.id)"
      @checklistCheck="checklistCheck"
      @guideReset="guideReset"
    ></guide>
  </div>
</template>

<script>
import CollapsibleBox from '../Shared/CollapsibleBox';
import Guide from './Guide';

export default {
  components: { CollapsibleBox, Guide },
  props: {
    initGuides: {
      type: Array,
      required: true
    },
    resetGuideText: {
      type: String,
      required: true
    },
    resetGuideUrl: {
      type: String,
      required: true
    },
    updateChecklistUrl: {
      type: String,
      required: true
    },
    updateVisibilityUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    checklistCheck(guideId, checklistItemId, isChecked) {
      this.$http.post(this.updateChecklistUrl, {
        guide: guideId,
        item: checklistItemId,
        checked: isChecked
      });
    },
    guideClosed(guideId) {
      this.$http.post(this.updateVisibilityUrl, {
        guide: guideId,
        visible: false
      });
    },
    guideOpened(guideId) {
      this.$http.post(this.updateVisibilityUrl, {
        guide: guideId,
        visible: true
      });
    },
    guideReset(guideId) {
      this.$http.post(this.resetGuideUrl, {
        guide: guideId
      });
    }
  }
};
</script>
